import Logger from './Logger';

class Application {
  public init() {
    Logger.log('Application init');
  }
}

export default new Application();
